import {DynamicFormBuilderComponent} from './dynamic-form-builder/dynamic-form-builder.component';
import {EformAPI} from '../e-form.api';
import {Section} from '../model/eform-type';
import {Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {Data} from '@angular/router';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {EformService} from '../service/eform.service';

@Component({
   selector: 'app-form-generate',
   templateUrl: './form-generate.component.html',
   styleUrls: ['./form-generate.component.scss']
})
export class FormGenerateComponent implements OnInit {
   @ViewChild(DynamicFormBuilderComponent) dynamicForm: DynamicFormBuilderComponent;
   public data: Data;
   public sections: Section[];
   formName = '';
   lang: any;
   @Input() isPreview: boolean = false;

   constructor(private dialogRef: MatDialogRef<FormGenerateComponent>, private api: EformAPI,
               @Inject(MAT_DIALOG_DATA) public dataDialog: any,
               public service: EformService) {
   }

   ngOnInit(): void {
      this.lang = localStorage.getItem('lang');
      this.getData(this.dataDialog.formId);
   }

   getData(formId: any) {
      if (formId !== '') {
         this.api.getEForm(formId).subscribe((res) => {
            this.data = res.body.data;
            switch(this.lang) {
               case 'th' :{
                  this.formName = this.data.formName.th
                  break;
               }
               case 'cn': {
                  this.formName = this.data.formName.cn
                  break;
               }
               default: {
                  this.formName = this.data.formName.en
               }
            }
            if (this.data.sections.length > 0) {
               this.sections = this.data.sections;
               this.checkedSectionName();
            }
         }, (err) => {
            console.error(err);
         });
      } else {
         this.data = this.dataDialog.formInfo;
         switch(this.lang) {
            case 'th' :{
               this.formName = this.data.formName.th
               break;
            }
            case 'cn': {
               this.formName = this.data.formName.cn
               break;
            }
            default: {
               this.formName = this.data.formName.en
            }
         }
         if (this.formName === '') {
            switch(this.data.original) {
               case 'th' :{
                  this.formName = this.data.formName.th
                  break;
               }
               case 'cn': {
                  this.formName = this.data.formName.cn
                  break;
               }
               case 'en': {
                  this.formName = this.data.formName.en
                  break;
               }
            }
         }
         if (this.data.sections.length > 0) {
            this.sections = this.data.sections;
            this.checkedSectionName();
         }
      }
   }

   checkedSectionName() {
      for (let indexSection = 0; indexSection < this.sections.length; indexSection++) {
         const fieldsLength = this.sections[indexSection].fields.length;
         for (let indexField = 0; indexField < fieldsLength; indexField++) {
            if (this.sections[indexSection].fields[indexField].fieldName === '') {
               this.sections[indexSection].fields[indexField].fieldNameEmpty = 'fieldName' + indexSection + indexField;
            }
         }
      }
   }

   onSubmit() {
      this.dynamicForm.onSubmit(this.isPreview);
   }

   onCheckSubmit(event: any) {
      if (event) {
         this.dialogRef.close(event);
      }
   }

   onClose() {
      this.dialogRef.close();
   }
}
